import api from './api'

/** Writes (criar folha) podem demorar; leituras de sync usam timeout curto. */
const RECEPTION_CHAT_WRITE_TIMEOUT_MS = 90_000
const RECEPTION_CHAT_READ_TIMEOUT_MS = 15_000

export interface ChatMessagePair {
  position: number
  question: string
  answer: string
}

export interface FollowUpPrompt {
  prefix: string
  questions: string[]
}

export interface ChatConversationResponse {
  conversationId: number
  messages: ChatMessagePair[]
  followUp?: FollowUpPrompt | null
  status?: number
  changedBy?: string
  dtChanged?: string
  workOrderId?: number
  workOrderNumber?: string
  scheduling?: boolean
  schedulingId?: number
  scheduledAt?: string
}

export interface ConversationSummary {
  conversationId: number
  status: number
  changedBy?: string
  dtChanged?: string
  lastMessage?: string
}

export const receptionChatService = {
  start: async (message: string, createdBy?: string) => {
    const response = await api.post<{ data: ChatConversationResponse }>(
      '/chat/reception/start',
      { message, createdBy },
      { timeout: RECEPTION_CHAT_WRITE_TIMEOUT_MS }
    )
    return response.data.data
  },

  startScheduling: async (scheduledAt: string, createdBy?: string) => {
    const response = await api.post<{ data: ChatConversationResponse }>(
      '/chat/reception/scheduling/start',
      { scheduledAt, createdBy },
      { timeout: RECEPTION_CHAT_WRITE_TIMEOUT_MS }
    )
    return response.data.data
  },

  sendMessage: async (conversationId: number, message: string, createdBy?: string) => {
    const response = await api.post<{ data: ChatConversationResponse }>(
      `/chat/reception/${conversationId}/message`,
      { message, createdBy },
      { timeout: RECEPTION_CHAT_WRITE_TIMEOUT_MS }
    )
    return response.data.data
  },

  getConversation: async (conversationId: number) => {
    const response = await api.get<{ data: ChatConversationResponse }>(
      `/chat/reception/${conversationId}`,
      { timeout: RECEPTION_CHAT_READ_TIMEOUT_MS }
    )
    return response.data.data
  },

  listDrafts: async () => {
    const response = await api.get<{ data: ConversationSummary[] }>('/chat/reception?status=0')
    return response.data.data
  },

  updateStatus: async (conversationId: number, status: 0 | 1, changedBy?: string) => {
    const response = await api.patch<{ data: ChatConversationResponse }>(`/chat/reception/${conversationId}/status`, {
      status,
      changedBy,
      dtChanged: new Date().toISOString(),
    })
    return response.data.data
  },

  deleteDraft: async (conversationId: number) => {
    await api.delete(`/chat/reception/${conversationId}`, { timeout: RECEPTION_CHAT_WRITE_TIMEOUT_MS })
  },
}

